<script lang="ts">
  import type { Snippet } from "svelte";
  interface Props {
    tone?: "neutral" | "accent" | "muted" | "future";
    children: Snippet;
    title?: string;
  }
  const { tone = "neutral", children, title }: Props = $props();
</script>

<span class="badge tone-{tone}" {title}>{@render children()}</span>

<style>
  .badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 11.5px;
    font-weight: 600;
    letter-spacing: 0;
    padding: 2px 9px;
    border-radius: var(--radius-chip);
    border: 1px solid var(--line);
    /* Site .tree .badge: --line hairline over a low-alpha accent wash, accent text. */
    background: var(--accent-fill);
    color: var(--accent);
    white-space: nowrap;
  }
  .tone-neutral {
    color: var(--text);
    border-color: var(--line-soft);
    background: var(--bg-2);
  }
  .tone-muted {
    color: var(--muted);
    border-color: var(--line-soft);
    background: transparent;
  }
  .tone-future {
    /* AA contrast: --state-readonly is too dim for 11.5px text on dark surfaces. */
    color: var(--muted);
    border-color: var(--dim-line);
    background: transparent;
    border-style: dashed;
  }
</style>
